/* RESPONSIBLE TEAM: team-inbox */
import ApplicationSerializer from './application';
import { inject as service } from '@ember/service';

// Map from MacroType enum values to type strings
const MACRO_TYPE_MAP = {
  0: 'opener',
  1: 'reply',
  2: 'note',
};
const ALL_TYPES = ['opener', 'reply', 'note'];

export default class SavedReplySerializer extends ApplicationSerializer {
  @service appService;

  get useInboxEndpoint() {
    return !!this.appService?.app?.canUseFeature('team-inbox-ensure-inbox-macros-correct-endpoint');
  }

  /**
   * Handle the new inbox endpoint response format for array responses.
   * New format: { saved_replies: { total, results } }
   * Old format: { saved_replies: [...] }
   */
  extractArrayPayload(modelName, payload) {
    if (!this.useInboxEndpoint) {
      return super.extractArrayPayload(modelName, payload);
    }

    // Handle new format: { saved_replies: { total, results } }
    if (payload.saved_replies && payload.saved_replies.results) {
      let extractedPayload = payload.saved_replies.results;
      extractedPayload.meta = {
        total: payload.saved_replies.total,
        ...payload.meta,
      };
      return extractedPayload;
    }

    // Fall back to default behavior for old format
    return super.extractArrayPayload(modelName, payload);
  }

  normalize(modelClass, resourceHash) {
    if (!this.useInboxEndpoint) {
      return super.normalize(modelClass, resourceHash);
    }

    // Transform new inbox endpoint fields to match expected model attributes
    if (resourceHash && !resourceHash.types && resourceHash.restricted_contexts !== undefined) {
      // Convert restricted_contexts (what's restricted) to types (what's allowed)
      // restricted_contexts: [0, 2] means restricted from opener and note, so types = ['reply']
      let restrictedContexts = resourceHash.restricted_contexts || [];
      let restrictedTypes = restrictedContexts.map((ctx) => MACRO_TYPE_MAP[ctx]).filter(Boolean);
      resourceHash.types = ALL_TYPES.filter((type) => !restrictedTypes.includes(type));
    }

    // Map author to admin_id if present
    if (resourceHash && resourceHash.author && !resourceHash.admin_id) {
      resourceHash.admin_id = resourceHash.author.id;
    }

    return super.normalize(modelClass, resourceHash);
  }
}
